import {
  DatePickerInput as MantineDatePickerInput,
  DatePickerInputProps,
  DatePickerType,
} from '@mantine/dates';
import {AdapterProps, FieldAdapter} from '../field-factory';

export type $DatePickerInputAdapterProps<
  Type extends DatePickerType = 'default',
> = AdapterProps<DatePickerInputProps<Type>>;

export const $DatePickerInputAdapter = <T extends DatePickerType>({
  inputProps: {onChange, ...inputProps},
  control,
}: FieldAdapter<AdapterProps<DatePickerInputProps<T>>>) => {
  const {
    field: {onChange: fieldOnChange, value = null, ...fieldProps},
    fieldState: {invalid},
  } = control;

  const _onChange: DatePickerInputProps<T>['onChange'] = (e) => {
    fieldOnChange(e);
    onChange?.(e);
  };

  return (
    <MantineDatePickerInput
      error={invalid}
      onChange={_onChange}
      value={value}
      {...fieldProps}
      {...inputProps}
    />
  );
};
